<template>
  <div
    v-if="healthdata"
    class="container"
  >
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4>Your Eating Habits Score</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              <linear-gauge
                :show-title="false"
                :show-display-val="false"
                :show-hero-metric="true"
                :title="healthdata.scorecard.factor_groups.eating.points"
                :value="healthdata.scorecard.factor_groups.eating.percentage"
              />
            </p>
          </div>
        </div>
      </div>

      <scorecard-eating-group
        :food-group-desc="displayData('vegetables')"
        :answers="healthdata.answers.eating.daily.vegetables"
      />
      <scorecard-eating-group
        :food-group-desc="displayData('fruit')"
        :answers="healthdata.answers.eating.daily.fruit"
      />
      <scorecard-eating-group
        :food-group-desc="displayData('breads')"
        :answers="healthdata.answers.eating.daily.breads"
      />
      <scorecard-eating-group
        :food-group-desc="displayData('dairy')"
        :answers="healthdata.answers.eating.daily.dairy"
      />
      <scorecard-eating-group
        :food-group-desc="displayData('protein')"
        :answers="healthdata.answers.eating.daily.protein"
      />
      <scorecard-eating-group
        :food-group-desc="displayData('fat')"
        :answers="healthdata.answers.eating.daily.fat"
      />

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-hamburger" /> Fast Food</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You eat at fast food restaurants <span :class="fastFoodData.class">{{ fastFoodData.text }}</span>.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-glass-whiskey" /> Water</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You are <span :class="waterData.class">{{ waterData.text }}</span>. You drink {{ numWaterGlasses }} per day.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-header text-center">
            <h4><i class="fa fa-coffee" /> Caffeine</h4>
          </div>
          <div class="card-body">
            <p class="text-center">
              You drink caffeinated and/or sugary drinks <span :class="caffeineData.class">{{ caffeineData.text }}</span>.
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-8 offset-lg-2 mb-4">
        <div class="card flex-grow-1">
          <div class="card-body text-center">
            <router-link
              class="btn btn-primary"
              :to="{name: 'scorecard'}"
            >
              &lt;&lt; Back to Scorecard
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    healthdata() {
      return this.$store.getters['healthData/current']
    },
    fastFoodData(){
      let freq = this.healthdata.answers.eating.fast_food.per_week;
      if (freq >= 7) return { text:'too frequently', class:'text-red'};
      if (freq >= 4) return { text:'frequently'    , class:'text-yellow-dark'};
      if (freq >= 2) return { text:'occasionally'  , class:'text-green-light'};
      if (freq >= 0) return { text:'rarely'        , class:'text-green'};
    },
    waterData(){
      let freq = this.healthdata.answers.eating.drinks.water.glasses_daily;
      if (freq > 8)  return { text:'very hydrated'   , class:'text-green'};
      if (freq >= 7) return { text:'hydrated'        , class:'text-green-light'};
      if (freq >= 5) return { text:'mildly hydrated' , class:'text-yellow-dark'};
      if (freq >= 0) return { text:'dehydrated'      , class:'text-red'};
    },
    caffeineData(){
      let freq = this.healthdata.answers.eating.drinks.caffeinated_sugar.glasses_daily;
      if (freq >= 3) return { text:'too frequently' , class:'text-red'};
      if (freq >= 2) return { text:'frequently'     , class:'text-yellow-dark'};
      if (freq >= 1) return { text:'occasionally'   , class:'text-yellow'};
      if (freq >= 0) return { text:'rarely'         , class:'text-green-light'};
    },
    numWaterGlasses(){
      let freq = this.healthdata.answers.eating.drinks.water.glasses_daily;
      return freq > 1 ? `${freq} glasses` : `${freq} glass`;
    },

  },
  mounted () {
    this.$store.dispatch('healthData/GET_INITIAL_DATA');
  },
  methods: {
    displayData(key){
      // hack to extract associated data from object's other property
      return this.healthdata.scorecard.food_spiral.food_groups.filter(group => group.group == key)[0];
    }
  }
}
</script>
